import Container from '@/components/@base/container';
import Rate from '@/components/@base/rate';
import { Text } from '@/components/@base/typography';

type Props = {
  rateAverage: number;
  averageUserRating: string;
};

export default function RateInfo({ rateAverage, averageUserRating }: Props) {
  return (
    <Container>
      <Container className='flex flex-col items-center md:items-start'>
        <Text className='text-[33px] font-bold leading-6 text-[#1F2025] lg:text-[40px]'>
          {(rateAverage || 0).toFixed(2)}
        </Text>
        <Text className='w-fit whitespace-nowrap text-[13px] font-light leading-8 tracking-tighter text-[#76767C] lg:text-[15px]'>
          {averageUserRating}
        </Text>
        <Container className='mt-1 w-[82px]'>
          <Rate value={rateAverage || 0} readOnly spaceInside='small' />
        </Container>
      </Container>
    </Container>
  );
}
